"use client";

import { c as _c } from "react/compiler-runtime";
import { AuthContext } from "@/components/auth/Auth";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { ApiProfileProxyActionType } from "@/generated/models/ApiProfileProxyActionType";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import Link from "next/link";
import { useContext, useEffect, useState } from "react";
export default function UserPageIdentityHeaderCICRateStats(t0) {
  const $ = _c(26);
  const {
    isTooltip,
    profile,
    minMaxValues,
    heroAvailableCredit
  } = t0;
  const {
    activeProfileProxy
  } = useContext(AuthContext);
  let t1;
  if ($[0] !== activeProfileProxy?.actions) {
    t1 = () => {
      const proxy = activeProfileProxy?.actions.find(_temp);
      if (!proxy) {
        return null;
      }
      return Math.max(0, (proxy.credit_amount ?? 0) - (proxy.credit_spent ?? 0));
    };
    $[0] = activeProfileProxy?.actions;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getProxyAvailableCredit = t1;
  const [proxyAvailableCredit, setProxyAvailableCredit] = useState(getProxyAvailableCredit());
  let t2;
  if ($[2] !== getProxyAvailableCredit) {
    t2 = () => setProxyAvailableCredit(getProxyAvailableCredit());
    $[2] = getProxyAvailableCredit;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== activeProfileProxy) {
    t3 = [activeProfileProxy];
    $[4] = activeProfileProxy;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== activeProfileProxy || $[7] !== heroAvailableCredit || $[8] !== proxyAvailableCredit) {
    t4 = () => {
      if (!activeProfileProxy) {
        return heroAvailableCredit;
      }
      return Math.abs(heroAvailableCredit) < Math.abs(proxyAvailableCredit ?? 0) ? heroAvailableCredit : proxyAvailableCredit ?? 0;
    };
    $[6] = activeProfileProxy;
    $[7] = heroAvailableCredit;
    $[8] = proxyAvailableCredit;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const getAvailableCredit = t4;
  let t5;
  if ($[10] !== getAvailableCredit) {
    t5 = getAvailableCredit();
    $[10] = getAvailableCredit;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const [availableCredit, setAvailableCredit] = useState(t5);
  let t6;
  if ($[12] !== getAvailableCredit) {
    t6 = () => setAvailableCredit(getAvailableCredit());
    $[12] = getAvailableCredit;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== heroAvailableCredit || $[15] !== proxyAvailableCredit) {
    t7 = [heroAvailableCredit, proxyAvailableCredit];
    $[14] = heroAvailableCredit;
    $[15] = proxyAvailableCredit;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  useEffect(t6, t7);
  let items;
  let t8;
  if ($[17] !== activeProfileProxy || $[18] !== availableCredit || $[19] !== isTooltip || $[20] !== minMaxValues || $[21] !== profile) {
    t8 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const proxyItem = activeProfileProxy ? {
        label: "Proxy for",
        value: <Link href={`/${activeProfileProxy.created_by.handle}`}>{activeProfileProxy.created_by.handle}</Link>,
        valueColorClassName: "tw-text-emerald-400",
        labelBreakAll: false
      } : null;
      const creditItem = activeProfileProxy ? null : {
        label: "Your available NIC:",
        value: formatNumberWithCommas(availableCredit),
        valueColorClassName: "tw-text-iron-300",
        labelBreakAll: false
      };
      const minMaxItem = activeProfileProxy ? null : {
        label: `Your max/min NIC Rating to ${profile.handle}:`,
        value: `+/- ${formatNumberWithCommas(minMaxValues.max)}`,
        valueColorClassName: "tw-text-iron-300",
        labelBreakAll: true
      };
      items = [proxyItem, creditItem, minMaxItem].filter(_temp2);
      if (isTooltip) {
        t8 = <div className="tw-text-xs tw-flex tw-flex-col tw-space-y-1.5">{items.map(_temp3)}</div>;
        break bb0;
      }
    }
    $[17] = activeProfileProxy;
    $[18] = availableCredit;
    $[19] = isTooltip;
    $[20] = minMaxValues;
    $[21] = profile;
    $[22] = items;
    $[23] = t8;
  } else {
    items = $[22];
    t8 = $[23];
  }
  if (t8 !== Symbol.for("react.early_return_sentinel")) {
    return t8;
  }
  let t9;
  if ($[24] !== items) {
    t9 = <div className="tw-rounded-lg tw-bg-white/[0.03] tw-border tw-border-solid tw-border-white/[0.06] tw-px-4 tw-py-3 tw-space-y-2.5">{items.map(_temp4)}</div>;
    $[24] = items;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
}
function _temp4(item_1) {
  return <div key={item_1.label} className="tw-flex tw-items-center tw-justify-between"><span className="tw-text-xs tw-text-iron-500 tw-font-medium">{item_1.label}</span><span className={`tw-whitespace-nowrap tw-text-xs tw-font-semibold ${item_1.valueColorClassName}`}>{item_1.value}</span></div>;
}
function _temp3(item_0) {
  return <span key={item_0.label} className={`tw-block tw-text-iron-500 tw-font-medium${item_0.labelBreakAll ? " tw-break-all" : ""}`}><span>{item_0.label.endsWith(":") ? item_0.label : `${item_0.label}:`}</span><span className={`tw-ml-1 tw-font-semibold ${item_0.valueColorClassName}`}>{item_0.value}</span></span>;
}
function _temp2(item) {
  return item !== null;
}
function _temp(action) {
  return action.action_type === ApiProfileProxyActionType.AllocateCic;
}